import script from "./InterviewList.vue?vue&type=script&setup=true&lang=ts"
export * from "./InterviewList.vue?vue&type=script&setup=true&lang=ts"

import "./InterviewList.vue?vue&type=style&index=0&id=ab0aaf2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab0aaf2e"]])

export default __exports__